import Auth from "./auth";
import Extras from "./extras";
import Request from "./request";

export default [...Auth, ...Request, ...Extras];
